module.exports = __webpack_public_path__ + "../assets/img/fa71d801ae9b14b3eb49b90542e991f4.svg";